import { motion } from "framer-motion";
import { Camera } from "lucide-react";
import { PORTRAIT_IMAGE } from "@/data/portfolioData";

const About = () => {
  return (
    <section id="about" data-testid="about-section-container" className="mx-auto max-w-7xl px-4 py-24 sm:px-8 lg:px-16 lg:py-32">
      <div className="grid grid-cols-1 items-center gap-14 lg:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, x: -32 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="relative"
        >
          <div className="absolute -left-4 -top-4 h-full w-full rounded-2xl border border-[#D4AF37]/30" />
          <img
            data-testid="about-photographer-portrait"
            src={PORTRAIT_IMAGE}
            alt="Coastal Choice Solutions photographer at work"
            className="relative aspect-[4/5] w-full rounded-2xl object-cover"
          />
          <div className="absolute -bottom-6 -right-4 flex items-center gap-3 rounded-2xl border border-white/10 bg-[#141419]/95 px-5 py-4 backdrop-blur-md sm:-right-6">
            <Camera size={20} className="text-[#D4AF37]" />
            <div>
              <div className="font-display text-sm font-bold text-zinc-50">Astoria, OR</div>
              <div className="text-[11px] text-zinc-400">serving the Oregon Coast</div>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 32 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
        >
          <p className="eyebrow-label mb-4">03 · Behind the Lens</p>
          <h2 className="font-display text-2xl font-bold tracking-tight text-zinc-50 sm:text-3xl lg:text-4xl">
            Every home has a best angle. We find it.
          </h2>
          <p data-testid="about-photographer-bio" className="mt-6 text-base leading-relaxed text-zinc-300">
            Coastal Choice Solutions is a real estate photography studio based in Astoria,
            Oregon. We specialize in interior and exterior photography, along with aerial
            drone coverage — giving agents and sellers across the Oregon Coast images that
            make buyers stop scrolling.
          </p>
          <p className="mt-4 text-base leading-relaxed text-zinc-400">
            From beachfront cottages to family homes in town, every shoot is captured,
            edited, and delivered by us — no handoffs, no week-long waits for your files.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
